import type { ButtonConfig } from '../../declare'
import { useMemo, useContext } from 'react'
import { toJS } from 'mobx'
import { Button } from 'antd'
import { EditPage, EasyModal, EasyIcon, FormPropsContext, ListPropsContext } from 'src/components'
import { appStore, listStore } from 'src/stores'
import { $consts } from 'src/plugins'
import { guid } from 'src/utils/tools'

type Props = {
  config: ButtonConfig
}

const EditListAddBtn = (props: Props) => {
  const table = listStore.table.get(useContext(ListPropsContext).formCode)

  const handleAdd = () => {
    const copyData = toJS(table.tableData.dataSource)
    copyData.splice(0, 0, {
      __EDITABLE__: true,
      ID: guid(),
      ORG_ID: appStore.current.headers.OrgId,
    })
    table.setTableData({ dataSource: copyData })
  }

  const { LABEL, ICON } = props.config
  return (
    <Button
      type='primary'
      icon={<EasyIcon type={ICON} defaultIcon='PlusOutlined' />}
      onClick={handleAdd}
    >{LABEL}</Button>
  )
}

const ListAddBtn = (props: Props) => {
  const formProps = useContext(FormPropsContext)
  const table = listStore.table.get(useContext(ListPropsContext).formCode)

  const handleModalClose = () => {
    table?.reload()
  }

  const fromEditRow = useMemo(() => {
    const fromWhere = formProps.formData?.fromWhere
    return (
      fromWhere?.pageType === $consts['TABLE/FORM_TYPE_EDIT_PAGE']
      && fromWhere?.locateType === $consts['TABLE/CONTROL_LOCATE_ROW']
      && fromWhere?.data
    )
  }, [formProps.formData?.fromWhere])

  const formData = useMemo(() => {
    return fromEditRow ? { initFormBase: fromEditRow } : {}
  }, [fromEditRow])

  const { LABEL, ICON, FORM_CODE, WIDTH } = props.config
  return (
    <EasyModal
      modal={{
        title: FORM_CODE,
        width: WIDTH,
        afterClose: handleModalClose,
      }}
      slot={<Button type='primary' icon={<EasyIcon type={ICON} defaultIcon='PlusOutlined' />}>{LABEL}</Button>}
    >
      <EditPage formCode={FORM_CODE} formData={formData} />
    </EasyModal>
  )
}

const AddBtn = (props: Props) => {
  const table = listStore.table.get(useContext(ListPropsContext).formCode)
  // 动态列可编辑列表表单
  if (table.tableConfig?.Nav_Form?.FORM_TYPE === $consts['TABLE/FORM_TYPE_DYNAMIC_EDITLIST_PAGE']) {
    return <EditListAddBtn config={props.config} />
  }
  // 列表表单
  return <ListAddBtn config={props.config} />
}

export default AddBtn